/** 结构化段落（内链 + 加粗） */

/** @param {Array<{ text?: string, strong?: boolean, link?: { to: string, text: string } }>} parts */
export function p(parts) {
	return { parts };
}
